import { formatISO9075, parseISO } from "date-fns"
import { zonedTimeToUtc } from "date-fns-tz"

export function getUTCDate(date: string | number | Date, representation?: "date" | "complete" | "time"): Date {
    const utcDate = zonedTimeToUtc(date, "Europe/Budapest")

    return parseISO(formatISO9075(utcDate, { representation }))
}
